import React from 'react';
import { findDOMNode } from 'react-dom';
import { TimelineLite } from 'gsap';
import ScrollMagic from "../../plugins/ScrollMagic";

export default {

    destroy(controller) {
        controller.destroy(true);
    },

    initialise(Component) {
        this.Node = findDOMNode(Component);
        this.items = [...this.Node.querySelectorAll('.column')];

        let controller = new ScrollMagic.Controller(),
            tl = new TimelineLite();

        if (this.items.length > 0) {
            tl.staggerFromTo(this.items, 1, {opacity: 0}, {opacity: 1}, 0.1);
        }

        new ScrollMagic.Scene({
            triggerElement: this.Node,
            offset: '100px',
            reverse: false
        })
            .setTween(tl)
            .addTo(controller);

        return controller;
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/modules/FiveColumn/animations.js